<template>
    <div id="user-access">
        <v-app-bar flat color="white" height="72" class="px-3" fixed app>
            <h2>User Access</h2>

            <v-spacer></v-spacer>

            <!-- Actions -->
            <template v-if="tab == 'users'">
                <v-btn to="/user-access/users/create" class="mx-1" outlined text v-if="isPermitted(userInfo.permissions, 'cms_users-store')"> <v-icon left> mdi-pencil </v-icon>Create </v-btn>
                <v-btn to="/user-access/users/invite-user" color="primary" class="ml-auto"> <v-icon left> mdi-plus </v-icon> Invite User </v-btn>
            </template>
            <template v-if="tab == 'roles'">
                <v-btn v-if="isPermitted(userInfo.permissions, 'cms_roles-index')" to="/user-access/roles/add" color="primary" class="ml-auto"> <v-icon left> mdi-plus </v-icon> Add Role </v-btn>
            </template>

            <!-- Tabs -->
            <template v-slot:extension>
                <v-tabs class="tabs ml-0" v-model="tab">
                    <v-tabs-slider color="indigo-lighten-3"></v-tabs-slider>
                    <template v-for="tab in tabs">
                        <v-tab v-if="userInfo.role.id === 'PARTNER' && tab.key === 'roles' ? false : true" :key="tab.key" :value="tab.value" :href="`#${tab.key}`" @click="updateActiveTab(tab.key)"> {{ tab.key }}</v-tab>
                    </template>
                </v-tabs>
            </template>
        </v-app-bar>

        <v-container fluid class="pa-6">
            <v-tabs-items v-model="tab">
                <!-- Users Data Table Tab -->
                <v-tab-item value="users">
                    <UsersDataTable />
                </v-tab-item>
                <!-- Roles Data Table Tab -->
                <v-tab-item value="roles">
                    <RolesDataTable />
                </v-tab-item>
            </v-tabs-items>
        </v-container>
    </div>
</template>

<script>
import UsersDataTable from '@/components/UserAccess/Users/DataTable.vue';
import RolesDataTable from '@/components/UserAccess/Roles/DataTable.vue';

export default {
    name: 'UserAccess',
    components: {
        UsersDataTable,
        RolesDataTable
    },
    data() {
        return {
            tab: window.location.hash ? window.location.hash.replace('#', '') : 'users',
            tabs: [
                {
                    key: 'users',
                    value: 'Users'
                },
                {
                    key: 'roles',
                    value: 'Roles'
                }
            ]
        };
    },
    computed: {},
    methods: {
        updateActiveTab(tab) {
            if (tab == 'users') history.replaceState(null, null, ' ');
        }
    }
};
</script>

<style lang="scss" scoped>
#user-access {
    .v-tab {
        color: #718096;
    }

    .v-tab--active {
        color: #1a202c;
    }
}
</style>
